import { Link } from "react-router-dom"
import { ReactNode } from "react"
import { Card, CardContent } from "./ui/card"

export function QuickAccessCard({ icon, title, href }) {
  return (
    <Link to={href} className="block group">
      <Card className="transition-all hover:shadow-md hover:-translate-y-1 duration-300 group-hover:border-primary">
        <CardContent className="flex flex-col items-center justify-center p-4 text-center">
          <div className="p-3 mb-3 rounded-full bg-gray-100 text-primary group-hover:bg-gray-200 transition-colors">
            {icon}
          </div>
          <h3 className="text-sm font-medium group-hover:text-primary transition-colors">{title}</h3>
        </CardContent>
      </Card>
    </Link>
  )
}
